import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Facebook, Linkedin, MapPin, Phone, Mail } from 'lucide-react';

const Footer = ({ onNavigate }) => {
  const { t, language } = useLanguage();

  const companyInfo = {
    fr: "Bali Life Concierge est une marque de la société PT Global Trade Belindo",
    en: "Bali Life Concierge is a brand of PT Global Trade Belindo",
    id: "Bali Life Concierge adalah merek dari PT Global Trade Belindo",
    es: "Bali Life Concierge es una marca de PT Global Trade Belindo"
  };

  return (
    <footer className="bg-[#1A1A2E] border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#C9A227] to-[#B8922B] flex items-center justify-center">
                <span className="text-white font-bold text-lg">BL</span>
              </div>
              <div>
                <h3 className="text-white font-playfair text-lg font-semibold">Bali Life</h3>
                <p className="text-[#C9A227] text-[10px] tracking-[0.2em] uppercase">Concierge & Real Estate</p>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-md mb-6">
              {t('footer.description')}
            </p>
            
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#C9A227] mt-0.5 flex-shrink-0" />
                <p className="text-white/60 text-sm">
                  Jalan Gootama, 22<br />
                  Gianyar, Ubud Bali
                </p>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#C9A227] flex-shrink-0" />
                <a href="tel:+6282123631370" className="text-white/60 text-sm hover:text-[#C9A227] transition-colors">
                  +62 821 2363 1370
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#C9A227] flex-shrink-0" />
                <a href="mailto:hello@balilifeconcierge.com" className="text-white/60 text-sm hover:text-[#C9A227] transition-colors">
                  hello@balilifeconcierge.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-medium mb-6">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => onNavigate('properties')} className="text-white/50 hover:text-[#C9A227] transition-colors text-sm">
                  {t('nav.properties')}
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('services')} className="text-white/50 hover:text-[#C9A227] transition-colors text-sm">
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button onClick={() => onNavigate('contact')} className="text-white/50 hover:text-[#C9A227] transition-colors text-sm">
                  {t('nav.contact')}
                </button>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-white font-medium mb-6">{t('footer.followUs')}</h4>
            <div className="flex items-center gap-3">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:border-[#C9A227]/50 hover:bg-[#C9A227]/10 transition-all">
                <Instagram className="w-4 h-4 text-white/70" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:border-[#C9A227]/50 hover:bg-[#C9A227]/10 transition-all">
                <Facebook className="w-4 h-4 text-white/70" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:border-[#C9A227]/50 hover:bg-[#C9A227]/10 transition-all">
                <Linkedin className="w-4 h-4 text-white/70" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mb-4">
            <p className="text-white/40 text-sm">
              © {new Date().getFullYear()} Bali Life Concierge. {t('footer.rights')}
            </p>
            <p className="text-white/40 text-sm">
              Ubud, Bali, Indonesia
            </p>
          </div>
          {/* Company Registration */}
          <p className="text-center text-white/30 text-xs">
            {companyInfo[language] || companyInfo.en}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
